/**
 * Orbi response-feedback types (PCSA-13171). Mirrors the mobile app
 * (`lib/orbi/models/orbi_feedback.dart`) for parity: a response can be marked
 * positive (thumbs-up) or negative (thumbs-down). These string values are sent
 * as the `feedback` field of the feedback request body.
 */
export enum OrbiFeedbackType {
  Positive = 'positive',
  Negative = 'negative',
}

/**
 * Negative-feedback issue categories (PCSA-13171). Mirrors the mobile
 * `NegativeFeedbackReason` enum exactly — same set, same display copy, and the
 * same snake_case wire values submitted in `feedbackReason[]`.
 */
export enum OrbiNegativeFeedbackReason {
  QuestionNotAnswered = 'question_not_answered',
  OffTopic = 'off_topic',
  Unclear = 'unclear',
  NotFactuallyAccurate = 'not_factually_accurate',
  Other = 'other',
}

/**
 * Display copy for each negative-feedback category (parity with mobile's
 * `NegativeFeedbackReason.displayName`). Keyed by the wire value so the UI can
 * render the label and submit the value from one source.
 */
export const ORBI_NEGATIVE_FEEDBACK_REASON_LABELS: Record<
  OrbiNegativeFeedbackReason,
  string
> = {
  [OrbiNegativeFeedbackReason.QuestionNotAnswered]:
    'It did not answer my question.',
  [OrbiNegativeFeedbackReason.OffTopic]: 'It went off topic.',
  [OrbiNegativeFeedbackReason.Unclear]: 'It was hard to understand.',
  [OrbiNegativeFeedbackReason.NotFactuallyAccurate]:
    'Some information was not correct.',
  [OrbiNegativeFeedbackReason.Other]: 'Other',
};
